import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import PegadaResumo from "@/components/pegada/PegadaResumo";
import PegadaVehiculo from "@/components/pegada/PegadaVehiculo";
import PegadaConcello from "@/components/pegada/PegadaConcello";
import PegadaFactores from "@/components/pegada/PegadaFactores";
import PegadaWhatIf from "@/components/pegada/PegadaWhatIf";
import "@/i18n/fase3";

export default function Pegada() {
  const { t } = useTranslation();
  const [period, setPeriod] = useState("year");
  const [tab, setTab] = useState("resumo");

  return (
    <div className="max-w-[1400px]" data-testid="pegada-root">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-6">
        <div>
          <div className="text-[11px] uppercase tracking-[0.28em] text-salnes-emerald mb-2">
            MRV
          </div>
          <h1 className="font-serif text-4xl lg:text-5xl text-salnes-ink leading-tight">
            {t("fase3.title")}
          </h1>
          <p className="mt-2 text-salnes-stone max-w-2xl text-sm">
            {t("fase3.subtitle")}
          </p>
        </div>
        <Select value={period} onValueChange={setPeriod}>
          <SelectTrigger className="w-[180px] h-10" data-testid="pegada-period">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="month">{t("fase2.last_30d")}</SelectItem>
            <SelectItem value="quarter">Q</SelectItem>
            <SelectItem value="year">YTD</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="bg-white border hairline rounded-full h-11 p-1 gap-1">
          <TabsTrigger value="resumo" data-testid="tab-resumo" className="rounded-full px-4">
            {t("fase3.tab_resumo")}
          </TabsTrigger>
          <TabsTrigger value="vehiculo" data-testid="tab-vehiculo" className="rounded-full px-4">
            {t("fase3.tab_vehicle")}
          </TabsTrigger>
          <TabsTrigger value="concello" data-testid="tab-concello" className="rounded-full px-4">
            {t("fase3.tab_concello")}
          </TabsTrigger>
          <TabsTrigger value="factores" data-testid="tab-factores" className="rounded-full px-4">
            {t("fase3.tab_factors")}
          </TabsTrigger>
          <TabsTrigger value="whatif" data-testid="tab-whatif" className="rounded-full px-4">
            {t("fase3.tab_whatif")}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="resumo" className="mt-6">
          <PegadaResumo period={period} />
        </TabsContent>
        <TabsContent value="vehiculo" className="mt-6">
          <PegadaVehiculo period={period} />
        </TabsContent>
        <TabsContent value="concello" className="mt-6">
          <PegadaConcello period={period} />
        </TabsContent>
        <TabsContent value="factores" className="mt-6">
          <PegadaFactores />
        </TabsContent>
        <TabsContent value="whatif" className="mt-6">
          <PegadaWhatIf />
        </TabsContent>
      </Tabs>
    </div>
  );
}
